import { Collapse } from 'react-collapse';
import { useTenant } from 'lib/hooks/useTenant';
import { Image } from 'components/Image/Image';

type Props = {
  id: string;
  title: string;
  context: string;
  click: () => void;
  isExpand: boolean;
  hasBorder: boolean;
};

// Row geometry shared with the loading placeholder in FAQ.tsx so the two cannot
// drift apart and the list does not jump when the real FAQs arrive.
export const faqRowWrapperClassName = (hasBorder: boolean) =>
  'border-light-800' + (!hasBorder ? '' : ' border-b');
export const faqRowClassName =
  'flex w-full min-h-[3.75rem] items-center justify-between gap-4 py-4';
export const faqTitleSizeClassName =
  'min-w-0 text-sm sm:text-base font-semibold';
export const faqIconBoxClassName = 'w-4 flex-none';

const FAQCard = ({ id, title, context, click, isExpand, hasBorder }: Props) => {
  const { isDA } = useTenant();
  const triggerId = `${id}-trigger`;
  const panelId = `${id}-panel`;

  return (
    <div className={faqRowWrapperClassName(hasBorder)}>
      <h3>
        <button
          id={triggerId}
          type="button"
          className={`${faqRowClassName} text-left`}
          aria-expanded={isExpand}
          aria-controls={panelId}
          onClick={click}
        >
          <span
            className={
              `${faqTitleSizeClassName} transition-all duration-300 ` +
              (isExpand
                ? `  ${isDA ? ' text-dealsaway-900 ' : ' text-teal-800  '}`
                : ' text-dark-800 ')
            }
          >
            {title}
          </span>
          <span className={faqIconBoxClassName} aria-hidden="true">
            {isExpand ? (
              <Image path="booking/icons/minus.svg" alt="" />
            ) : (
              <Image path="booking/icons/plus.svg" alt="" />
            )}
          </span>
        </button>
      </h3>
      <Collapse
        isOpened={isExpand}
        initialStyle={{ height: 0, overflow: 'hidden' }}
      >
        <div
          id={panelId}
          role="region"
          aria-labelledby={triggerId}
          aria-hidden={!isExpand}
          className="pb-5"
        >
          <div
            className={
              'bg-light-700 rounded-md px-4 py-3 sm:py-2.5 text-xs sm:text-sm text-dark-600 !leading-5 overflow-hidden inner-html '
            }
            dangerouslySetInnerHTML={{ __html: context }}
          ></div>
        </div>
      </Collapse>
    </div>
  );
};

export { FAQCard };
